import React, { useEffect, useState } from 'react';
import { auth, db } from '../../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { readSettings, writeSettings } from '../../utils/settings';

export default function SettingsNotifications() {
  const [emailNotif, setEmailNotif] = useState(true);
  const [smsNotif, setSmsNotif] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsub = onAuthStateChanged(auth, async () => {
      setLoading(true);
      const { settings } = await readSettings(auth, db);
      setEmailNotif(!!settings.emailNotifications);
      setSmsNotif(!!settings.smsNotifications);
      setMarketing(!!settings.marketing);
      setLoading(false);
    });
    return () => unsub && unsub();
  }, []);

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen">
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-5xl">
        <h1 className="text-2xl font-bold mb-4 text-text-dark dark:text-text-light">Bildirim Tercihleri</h1>
        <div className="panel rounded-xl shadow p-6 space-y-4">
          <div className="flex items-center justify-between">
            <span>E-posta Bildirimleri</span>
            <input
              type="checkbox"
              disabled={loading}
              checked={emailNotif}
              onChange={async (e)=>{
                const v = e.target.checked; setEmailNotif(v);
                await writeSettings(auth, db, { emailNotifications: v });
              }} />
          </div>
          <div className="flex items-center justify-between">
            <span>SMS Bildirimleri</span>
            <input
              type="checkbox"
              disabled={loading}
              checked={smsNotif}
              onChange={async (e)=>{
                const v = e.target.checked; setSmsNotif(v);
                await writeSettings(auth, db, { smsNotifications: v });
              }} />
          </div>
          <div className="flex items-center justify-between">
            <span>Pazarlama İletişimi</span>
            <input
              type="checkbox"
              disabled={loading}
              checked={marketing}
              onChange={async (e)=>{
                const v = e.target.checked; setMarketing(v);
                await writeSettings(auth, db, { marketing: v });
              }} />
          </div>
        </div>
      </main>
    </div>
  );
}
